"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NightShift = void 0;
const linkedShift_1 = require("./linkedShift");
class NightShift extends linkedShift_1.LinkedShift {
    constructor(linkedId, required, options) {
        super(linkedId, required, options);
    }
    isNightShift() {
        return true;
    }
}
exports.NightShift = NightShift;
